import { EPromoInventoryActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeForceClosedBanner = actionGenerator<EPromoInventoryActionType.ForceClosedBannerChanged, boolean>(
  EPromoInventoryActionType.ForceClosedBannerChanged,
);
